// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "./admin_layout";
import "./user_layout";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker")
      .then((registration) => {
        console.log(
          "ServiceWorker registration successful with scope: ",
          registration.scope
        );
      })
      .catch((err) => {
        console.log("ServiceWorker registration failed: ", err);
      });
  });
} else {
  console.log("Browser does not support service workers.");
}
